module.exports = __webpack_public_path__ + "img/dollar.0c98f98e.svg";